export const INVALID = 'INVALID';
export const NOT_YET_VALIDATED = 'NOT_YET_VALIDATED';
export const PENDING = 'PENDING';
export const VALID = 'VALID';
export const UNKNOWN = 'UNKNOWN';